import React, { Fragment, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import moment from "moment";
import { dayBookReport } from "../../../services/accounts";
import { exportPDF, exportExcel } from "./exportUtils";

const TYPE_BADGE = { Receipt: "bg-success", Payment: "bg-danger", Journal: "bg-warning text-dark", Contra: "bg-info" };

export default function DayBook() {
  const [date, setDate]       = useState(moment().format("YYYY-MM-DD"));
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);

  function handleSearch() {
    setLoading(true);
    const temp = new FormData();
    temp.append("date", date);
    if (localStorage.getItem("Role") === "1") {
      temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    }
    dayBookReport(temp).then((res) => {
      setLoading(false);
      if (res?.status) setData(res.data);
    });
  }

  function getExportData() {
    const columns = ["Voucher No", "Type", "Narration", "Ledger", "Debit", "Credit"];
    const rows = [];
    data?.vouchers?.forEach((v) => {
      v.items?.forEach((item) => {
        rows.push([
          v.voucher_no,
          v.voucher_type,
          v.narration || "",
          item.ledger?.ledger_name || "",
          parseFloat(item.debit_amount) > 0  ? parseFloat(item.debit_amount).toFixed(2)  : "",
          parseFloat(item.credit_amount) > 0 ? parseFloat(item.credit_amount).toFixed(2) : "",
        ]);
      });
    });
    return { columns, rows };
  }

  const title = `Day Book - ${moment(data?.date).format("DD MMM YYYY")}`;

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Day Book</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Accounts</a></li>
            <li className="breadcrumb-item active" aria-current="page">Day Book</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Date <span className="text-danger"> *</span></label>
                    <input type="date" className="form-control" value={date} onChange={(e) => setDate(e.target.value)} />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">&nbsp;</label>
                    <div>
                      <a onClick={handleSearch} className="btn btn-success">{loading ? "Loading..." : "Show"}</a>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          {data && (
            <div className="card custom-card mg-b-20">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Day Book — {moment(data.date).format("DD MMM YYYY")}</h5>
                  <div>
                    <a onClick={() => { const { columns, rows } = getExportData(); exportPDF(title, columns, rows); }} className="btn btn-danger btn-sm me-2">
                      <i className="fa fa-file-pdf-o me-1" /> PDF
                    </a>
                    <a onClick={() => { const { columns, rows } = getExportData(); exportExcel(title, columns, rows); }} className="btn btn-success btn-sm">
                      <i className="fa fa-file-excel-o me-1" /> Excel
                    </a>
                  </div>
                </div>
                {data.vouchers?.length === 0 && <p className="text-muted">No transactions for this date.</p>}
                {data.vouchers?.map((v, i) => (
                  <Card key={i} className="mb-3 border">
                    <Card.Header className="py-2 d-flex justify-content-between align-items-center">
                      <span>
                        <span className={`badge ${TYPE_BADGE[v.voucher_type] || "bg-secondary"} me-2`}>{v.voucher_type}</span>
                        <strong>{v.voucher_no}</strong>
                      </span>
                      <span className="text-muted">{v.narration}</span>
                    </Card.Header>
                    <Card.Body className="p-0">
                      <table className="table table-sm mb-0">
                        <thead style={{ backgroundColor: "#2d4ac6", color: "#fff" }}>
                          <tr>
                            <th style={{ color: "#fff" }}>Ledger</th>
                            <th className="text-end" style={{ color: "#fff" }}>Debit</th>
                            <th className="text-end" style={{ color: "#fff" }}>Credit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {v.items?.map((item, j) => (
                            <tr key={j}>
                              <td>{item.ledger?.ledger_name}</td>
                              <td className="text-end">{parseFloat(item.debit_amount) > 0  ? parseFloat(item.debit_amount).toFixed(2)  : ""}</td>
                              <td className="text-end">{parseFloat(item.credit_amount) > 0 ? parseFloat(item.credit_amount).toFixed(2) : ""}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
}
